import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../assets/css/footer.css';



function Footer() {

    return (
    <motion.footer
      className="yb-footer glass-footer"
      role="contentinfo"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      <div className="yb-footer-inner">
        <div className="yb-footer-grid">
          {/* Left: Logo + Tagline */}
          <div className="yb-footer-brand">
            <img
              src={require('../assets/images/frontlogo.png')}
              alt="Yemberzal — Kashmiri Fashion Discovery Platform"
              className="yb-footer-logo"
              // zoom in the image to 100px more than the original size
              style={{ width: '250px', height: '200px', objectFit: 'cover' }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = '/default-image.avif';
              }}
            />
            {/* <span className="yb-footer-wordmark">YEMBERZAL</span>
            <span className="yb-footer-tagline">Kashmiri Fashion Discovery Platform.</span> */}
          </div>

          {/* Middle: Nav Links — using <Link> for crawlability */}
          <nav className="yb-footer-nav" aria-label="Footer navigation">
            <span className="yb-footer-nav-title">Explore</span>
            <Link to="/" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Home</Link>
            <Link to="/discover" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Discover</Link>
            <Link to="/shop" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Shop</Link>
            <Link to="/brands" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Brands</Link>
            <Link to="/blog" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Blog</Link>
            <Link to="/vision" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Vision</Link>
            <Link to="/partner" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Partner</Link>
            <Link to="/contact" className="yb-footer-link" onClick={() => window.scrollTo(0, 0)}>Contact</Link>
          </nav>

          {/* Right: Socials */}
          <div className="yb-footer-socials">
            <span className="yb-footer-nav-title">Connect</span>
            <a
              href="https://www.instagram.com/yemberzal.kash"
              target="_blank"
              rel="noopener noreferrer"
              className="yb-footer-link"
            >
              Instagram
            </a>
            <a
              href="mailto:contact@theyemberzal.com"
              className="yb-footer-link"
            >
              Email
            </a>
          </div>
        </div>

        <div className="yb-footer-bottom">
          <span className="yb-footer-meta">© {new Date().getFullYear()} Yemberzal. A love letter to Kashmir.</span>
        </div>
      </div>
    </motion.footer>
  );
}

export default Footer;
